import React from 'react';

import './style.scss';

export interface ICrossProps {
  size: number;
  onClick: () => void;
}

const Cross: React.FunctionComponent<ICrossProps> = ({ size, onClick }) => {
  const sizeInPx = `${size}px`;

  const styles: React.CSSProperties = {
    height: sizeInPx,
    width: sizeInPx,
    backgroundSize: sizeInPx,
  };

  return <div className="cross" style={styles} onClick={onClick} />;
};

export default Cross;
